import { Pipe, PipeTransform } from "@angular/core";
import { isUnspecified } from "./is-unspecified";

@Pipe({
  standalone: false,
  name: "locationDisplay",
})
export class LocationDisplayPipe implements PipeTransform {
  transform(location: string) {
    return isUnspecified(location) ? "" : location;
  }
}
